import React from 'react'
import * as S from './style'

const NegationButton = ({ title, onClick, disabled }) => {
  return (
    <>
      <S.Button onClick={onClick} type="button" disabled={disabled} data-testid='negation-button-test-id'>
        <S.Text>{title}</S.Text>
      </S.Button>
    </>
  )
}

export { NegationButton }
